import {
	CONDUCTOR_APP_URL,
	CONTENTKING_CONDUCTOR_APP_URL,
} from '~/config';

import {
	getRouterState,
} from '~/routing/router';



export function getConductorLoginLink(redirectPath: string | null = null) {
	const redirectUri = redirectPath !== null
		? `&redirectUri=${encodeURIComponent(CONTENTKING_CONDUCTOR_APP_URL + redirectPath)}`
		: '';

	// Add unauthenticated=true only when there's a redirect path (unauthenticated redirect scenario)
	const unauthenticatedParam = redirectPath !== null
		? 'unauthenticated=true&'
		: '';

	return `${CONDUCTOR_APP_URL}/login.html?${unauthenticatedParam}ckBanner=true${redirectUri}`;
}



export function redirectToConductorLogin() {
	const urlState = getRouterState();

	window.location.href = getConductorLoginLink(urlState.path);
}
